(function () {
  function initPickup() {
    const checkBtn = document.getElementById('pickup-availability');
    const drawer = document.getElementById('pickup-modal');
    const closeBtn = document.getElementById('pickup-modal-close');
    const overlay = drawer?.querySelector('.pickup-drawer-overlay');
    const locationsEl = document.getElementById('pickup-locations');
    if (!checkBtn || !drawer) return;

    async function fetchAvailability(variantId) {
      locationsEl.setAttribute('aria-busy', 'true');
      locationsEl.innerHTML = '<p style="padding: 16px 0; color: var(--color-text); font-size: var(--font-size-sm);">Loading...</p>';
      try {
        const res = await fetch(
          `${window.Shopify.routes.root}variants/${variantId}/?section_id=store-availability`
        );
        if (!res.ok) throw new Error('Failed');
        const html = await res.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const inner = doc.querySelector('#pickup-locations-inner');
        locationsEl.innerHTML = inner
          ? inner.innerHTML
          : '<p style="padding: 16px 0; color: var(--color-text); font-size: var(--font-size-sm);">No pickup locations found.</p>';
      } catch {
        locationsEl.innerHTML = '<p style="padding: 16px 0; color: var(--color-error); font-size: var(--font-size-sm);">Could not load pickup availability.</p>';
      } finally {
        locationsEl.setAttribute('aria-busy', 'false');
      }
    }

    function openDrawer() {
      const variantId = checkBtn.dataset.variantId;
      drawer.classList.add('open');
      checkBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      closeBtn.focus();
      fetchAvailability(variantId);
    }

    function closeDrawer() {
      drawer.classList.remove('open');
      checkBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      checkBtn.focus();
    }

    checkBtn.addEventListener('click', openDrawer);
    closeBtn.addEventListener('click', closeDrawer);
    overlay?.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && drawer.classList.contains('open')) closeDrawer();
    });

    drawer.addEventListener('keydown', e => {
      if (e.key !== 'Tab') return;
      const focusable = drawer.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });

    document.addEventListener('variantChanged', e => {
      if (e.detail?.variantId) {
        checkBtn.dataset.variantId = e.detail.variantId;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPickup);
  } else {
    initPickup();
  }
})();